import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  touchHandler: {
    sponserBank: false,
    frequency: false,
    debitType: false,
    fbd: false,
    mandateStartDate: false,
    firstNachBillingDate: false,
    mandateValidity: false,
    mandateAmt: false,
    nachAmt: false,
  },
};
const NachStore = createSlice({
  name: "Nach",
  initialState: initialState,
  reducers: {
    setResetTouchHandler(state, action) {
      state.touchHandler.sponserBank = action.payload;
      state.touchHandler.frequency = action.payload;
      state.touchHandler.debitType = action.payload;
      state.touchHandler.fbd = action.payload;
      state.touchHandler.mandateStartDate = action.payload;
      state.touchHandler.firstNachBillingDate = action.payload;
      state.touchHandler.mandateValidity = action.payload;
      state.touchHandler.mandateAmt = action.payload;
      state.touchHandler.nachAmt = action.payload;
    },

    updateSponserBankTouchHandler(state, action) {
      state.touchHandler.sponserBank = action.payload;
    },
    updateFrequencyTouchHandler(state, action) {
      state.touchHandler.frequency = action.payload;
    },
    updateDebitTypeTouchHandler(state, action) {
      state.touchHandler.debitType = action.payload;
    },
    updateMandateValidityTouchHandler(state, action) {
      state.touchHandler.mandateValidity = action.payload;
    },
    updateNachAmtTouchHandler(state, action) {
      state.touchHandler.nachAmt = action.payload;
    },
    updateMandateAmtTouchHandler(state, action) {
      state.touchHandler.mandateAmt = action.payload;
    },
    updateFbdTouchHandler(state, action) {
      state.touchHandler.fbd = action.payload;
    },
    updateMandateStartDateTouchHandler(state, action) {
      state.touchHandler.mandateStartDate = action.payload;
    },
    updateFirstNachBillingDateTouchHandler(state, action) {
      state.touchHandler.firstNachBillingDate = action.payload;
    },
  },
});
export const NachAction = NachStore.actions;
export default NachStore.reducer;
